import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import ServiceHeroSection from './components/ServiceHeroSection';
import ServiceFlowSection from './components/ServiceFlowSection';
import ServiceFeaturesSection from './components/ServiceFeaturesSection';
import ServiceCTASection from './components/ServiceCTASection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const serviceJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  url: `${SITE_URL}/service`,
  name: '東京シニア婚活サービス | 縁結び 和はは',
  description: '東京のシニア向け婚活相談所「縁結び和はは」のサービス内容。50代・60代・70代の婚活マッチング・カウンセリング・お見合いサポート。',
  provider: {
    '@type': 'LocalBusiness',
    name: '縁結び 和はは',
    url: SITE_URL,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '東京都',
      addressRegion: '東京',
      addressCountry: 'JP',
    },
  },
  areaServed: ['東京都', '神奈川県', '埼玉県', '千葉県', '関東'],
  serviceType: 'シニア婚活相談所',
  audience: {
    '@type': 'PeopleAudience',
    suggestedMinAge: 50,
    audienceType: '50代・60代・70代のシニア',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'サービス内容', item: `${SITE_URL}/service` },
    ],
  },
};

export default function ServicePage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活サービス内容 | 縁結び 和はは 婚活相談所"
        description="東京のシニア婚活相談所「縁結び和はは」のサービス内容。婚活東京シニア専門で50代・60代・70代の出会いから成婚まで丁寧にサポート。カウンセリング・お見合い・アフターフォローが充実した東京のシニア婚活。"
        keywords="東京 シニア 婚活, 婚活相談所 東京 サービス, シニア婚活マッチング, 50代婚活東京, 60代婚活東京, 婚活カウンセリング東京"
        path="/service"
        jsonLd={serviceJsonLd}
      />
      <Navbar />
      <main>
        <ServiceHeroSection />
        <ServiceFlowSection />
        <ServiceFeaturesSection />
        <ServiceCTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
